import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import './assets/css/alipes.css'
import './assets/css/ourupdate.css'
import './assets/css/alipes-responsive.css'
import './assets/css/footer.css'

import './assets/vendors/bootstrap/css/bootstrap.min.css'
import './assets/vendors/animate/animate.min.css'
import './assets/vendors/animate/custom-animate.css'
import './assets/vendors/fontawesome/css/all.min.css'
import './assets/vendors/jarallax/jarallax.css'
import './assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css'
import './assets/vendors/nouislider/nouislider.min.css'
import './assets/vendors/nouislider/nouislider.pips.css'
import './assets/vendors/odometer/odometer.min.css'
import './assets/vendors/swiper/swiper.min.css'
import './assets/vendors/alipes-icons/style.css'
import './assets/vendors/tiny-slider/tiny-slider.min.css'
import './assets/vendors/reey-font/stylesheet.css'
import './assets/vendors/owl-carousel/owl.carousel.min.css'
import './assets/vendors/owl-carousel/owl.theme.default.min.css'
import './assets/vendors/bxslider/jquery.bxslider.css'
import './assets/vendors/bootstrap-select/css/bootstrap-select.min.css'
import './assets/vendors/vegas/vegas.min.css'
import './assets/vendors/jquery-ui/jquery-ui.css'
import './assets/vendors/timepicker/timePicker.css'
import './assets/vendors/nice-select/nice-select.css'
import { Toaster } from "react-hot-toast";


createRoot(document.getElementById('root')).render(
  <StrictMode>
     <Toaster position="top-center" reverseOrder={false} />
    <App />
  </StrictMode>

)
